import { SiteType } from 'graphql/types/SiteType';

export type SitesPageContext = 'central' | 'wms';

interface SiteInfoEditPermissionInput {
    pageContext: SitesPageContext;
    siteType?: SiteType | number;
    isHQ: boolean;
    isHubMgr: boolean;
    isHQAdmin: boolean;
}

/**
 * AreaZipcodesForm 查车队用的仓库 ID。
 *
 * 必须使用「仓库详情已加载完成」后的 warehouse.id，而不能使用全局 store 中
 * 点击切换瞬间就变化的 warehouseId。否则会出现：旧表单仍挂载 → 用新 ID 发
 * GetDspsByWarehouseId → 仓库详情加载中 isWarehouse 变 false → 表单卸载 →
 * Apollo abort → 加载完再挂载再发一次（CF 隧道偏斜误报根因）。
 */
export function resolveAreaZipcodesFormWarehouseId(
    loadedWarehouse: { id?: number } | null | undefined,
): number | undefined {
    return loadedWarehouse?.id ?? undefined;
}

/**
 * 中心信息 / 地址信息卡片的编辑按钮显隐逻辑。
 *
 * - 总部站点管理（central）：仅总部管理员可编辑地址信息
 * - WMS 站点管理（wms）：复用双卡片布局，地址信息只读，隐藏地址编辑按钮
 */
export function getSiteInfoEditPermissions({
    pageContext,
    siteType,
    isHQ,
    isHubMgr,
    isHQAdmin,
}: SiteInfoEditPermissionInput) {
    const isHub = siteType === SiteType.HUB || siteType === 1;
    const isWarehouse = siteType === SiteType.WAREHOUSE || siteType === 2;
    const hasSiteManageRole = isHQ || isHubMgr;

    const canEditHubCenter = isHub && hasSiteManageRole;
    const canEditWarehouseCenter = isWarehouse && hasSiteManageRole;

    const canEditCenterInfo = isHub ? canEditHubCenter : canEditWarehouseCenter;

    const canEditAddressInfo =
        pageContext === 'wms'
            ? false
            : isHQAdmin;

    return {
        isHub,
        isWarehouse,
        canEditCenterInfo,
        canEditAddressInfo,
    };
}
